module.exports = __webpack_public_path__ + "assets/img/water.d001702e.png";